// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { Jumbotron } from 'reactstrap'
import Form from './Form'
import ComsearchConnectVideo from './ComsearchConnectVideo'
import ProtectionMetrics from './ProtectionMetrics'
import bgImage from 'images/connectedCircles2.png'
import { SignInPageWrapper } from './styles'

const style = {
  backgroundImage: `url(${bgImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}

const SignIn = () => (
  <>
    <ProtectionMetrics />
    <SignInPageWrapper style={style}>
      {
        /Trident\/|MSIE/.test(window.navigator.userAgent) &&
        <div className={'width-100 display-flex justify-content-center'}>
          <Jumbotron>
            <p>
              {'For the best user-experience, '}
              <a
                href={'https://www.google.com/chrome/'}
                rel={'noopener noreferrer'}
                target={'_blank'}>
                {'Google Chrome'}
              </a>
              {' is recommended over Microsoft Internet Explorer.'}
            </p>
          </Jumbotron>
        </div>
      }
      <Form />
      <ComsearchConnectVideo />
    </SignInPageWrapper>
  </>
)

export default SignIn
